import React from "react";
import PropTypes from "prop-types";
import { Box, Container, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";
import SplitterLayout from "react-splitter-layout";
import "react-splitter-layout/lib/index.css";
import TemplateBox from "components/TemplateBox";
import CaseDetailsContent from "../CaseDetailsContent";
import { useTemplateController } from "context";

function CaseDetailsSplit({ onClose, rowData, language }) {
  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));
  const data = rowData && rowData.length > 0 ? rowData[0] : {};
const [controller] = useTemplateController();
  const { darkMode } = controller;
  return (
    <>
      <SplitterLayout
        vertical={mobileDevice}
        percentage={true}
        primaryMinSize={30}
        secondaryMinSize={30}
        secondaryInitialSize={50}
      >
        <div>
          <TemplateBox height="20px" />
          <Box
            sx={{
              position: "sticky",
              top: 0,
              display: "flex",
              justifyContent: "flex-end", // Aligns icon to the right
              alignItems: "center",
              zIndex: 10,
              bgcolor: darkMode ? "#1f2020" : "background.paper",
              p: 2,
              borderRadius: 2, // Adds rounded corners
              boxShadow: 1, // Adds shadow similar to a card
            }}
          >
            <IconButton color="secondary" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Container maxWidth="lg">
            <CaseDetailsContent data={data} language={language} />
          </Container>
        </div>
      </SplitterLayout>
    </>
  );
}

CaseDetailsSplit.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired,
};

export default CaseDetailsSplit;
